module.exports = __webpack_public_path__ + "static/media/deepdive.af44da58.png";